export function scrollToBottom(selector: string) {
  const el = document.querySelector(selector);
  if (!el) return;

  const start = el.scrollTop;
  const end = el.scrollHeight - el.clientHeight;
  const distance = end - start;
  const duration = 300;
  const startTime = performance.now();

  function step(currentTime: number) {
    if (!el) return; // 🔹 segurança adicional
    const progress = Math.min((currentTime - startTime) / duration, 1);
    const ease = 0.5 - Math.cos(progress * Math.PI) / 2;
    el.scrollTop = start + distance * ease;
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}
